module.exports = __webpack_public_path__ + "static/6-5c7cf4241905e85a50f439b2bc82dd23.jpeg";